import Icon from "@afa-shared/afa-components/dist/Icon";
import { ContentLink } from "@components/Link/ContentLink";
import { navigationTracker } from "@components/navigation/NavigationTracker";
import { richTextToPlainTextString } from "@utils/string";

import { FactsStructureSearch } from "types/FactsStructureSearch";
import { FactsStructureSearchItem } from "types/FactsStructureSearchItem";

import breadcrumbStyles from "../../../styles/breadcrumbs.module.css";

export const getRichText = (json: any): string => {
  const stringifiedText = richTextToPlainTextString(json);
  const richText = stringifiedText?.slice(0, 150).trimEnd();
  return richText ? richText + "..." : "";
};

export const getPageBreadCrumbs = (
  item: FactsStructureSearchItem,
  factsStructure: FactsStructureSearch,
): React.ReactNode => {
  const path = item?.url?.replace("/forsakringshandboken/", "");
  const slugs = path?.split("/");
  const breadCrumbsArray = [];

  if (!factsStructure?.flatStructure?.length && !slugs?.length) return null;
  else {
    breadCrumbsArray?.push("Försäkringshandboken");
    for (const slug of slugs) {
      const foundStructureItem = factsStructure?.flatStructure?.filter(
        (factsItem) => factsItem.slug === slug,
      )[0];

      if (!foundStructureItem) return;

      breadCrumbsArray.push(foundStructureItem?.name);
    }
  }

  return breadCrumbsArray?.length > 0 ? (
    <ul className={breadcrumbStyles.breadCrumbs}>
      {breadCrumbsArray.map((breadCrumbItem, index) => (
        <li key={index}>
          {breadCrumbItem}
          {index !== breadCrumbsArray?.length - 1 && (
            <Icon name="chevron_right" size="sm" className={breadcrumbStyles.icon} />
          )}
        </li>
      ))}
    </ul>
  ) : null;
};

export const getTopBreadCrumbLinks = (): any[] => {
  const topBreadCrumbs = [];
  topBreadCrumbs?.push(
    <ContentLink
      href="/forsakringshandboken"
      onClick={() =>
        navigationTracker("Försäkringshandboken", "Utbildning och material", "breadcrumbs")
      }
      noTracking={true}
      contentText="Försäkringshandboken"
    >
      Försäkringshandboken
    </ContentLink>,
  );
  topBreadCrumbs?.push(
    <ContentLink
      href="/sok-i-handboken"
      onClick={() =>
        navigationTracker("Sök i försäkringshandboken", "Utbildning och material", "breadcrumbs")
      }
      noTracking={true}
      aria-current="page"
      contentText="Sök i Försäkringshandboken"
    >
      Sök i Försäkringshandboken
    </ContentLink>,
  );
  return topBreadCrumbs;
};

export const getFilteredItems = (
  query: string,
  pages: FactsStructureSearchItem[],
): FactsStructureSearchItem[] => {
  const filteredItems = pages?.filter((item: FactsStructureSearchItem) => {
    return (
      item?.heading?.toLowerCase().includes(query?.toLowerCase()) ||
      item?.preamble?.toLowerCase().includes(query?.toLowerCase()) ||
      richTextToPlainTextString(item?.mainbody?.json).toLowerCase().includes(query?.toLowerCase())
    );
  });
  return filteredItems;
};
